import { Machine } from '../../gql/generated';
import { hasMachineSignals } from '../../utils/machineDisplay';
import { MachineSignalCategories } from './MachineSignalCategories';

interface MachineMetricsSectionProps {
  availableSignals: Machine['availableSignals'];
}

/** The machine's signals as a section of the compact detail page. */
export function MachineMetricsSection({
  availableSignals,
}: MachineMetricsSectionProps) {
  if (!hasMachineSignals(availableSignals)) return null;

  return (
    <section className='flex flex-col gap-3'>
      <h3 className='size-caption text-primary tracking-[0.08em] uppercase'>
        Available metrics
      </h3>

      <div
        className='bg-surface-primary border-border-secondary flex flex-col
          rounded-xl border px-4 shadow-[0_4px_12px_rgba(0,0,0,0.03)]'
      >
        <MachineSignalCategories
          availableSignals={availableSignals}
          layout='list'
        />
      </div>
    </section>
  );
}
